import { render, staticRenderFns } from "./resetPasswordPage.vue?vue&type=template&id=432f2792&"
import script from "./resetPasswordPage.vue?vue&type=script&lang=ts&"
export * from "./resetPasswordPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports